import { CALL_API } from "../api.middleware";
import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_FAILED,
  GET_TRANSACTION_DATA,
  GET_TRANSACTION_DATA_SUCCESS,
  GET_TRANSACTION_DATA_FAILED,
  GET_AUM_DATA,
  GET_AUM_DATA_SUCCESS,
  GET_AUM_DATA_FAILED,
  GET_FREQUENT_MAIL_BACK_REQUEST,
  GET_FREQUENT_MAIL_BACK_REQUEST_FAILED,
  GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS,
  GET_DASHBOARD_AUM_DATA,
  GET_DASHBOARD_AUM_DATA_SUCCESS,
  GET_DASHBOARD_AUM_DATA_FAILED,
  GET_SIP_SUMMARY_DATA,
  GET_SIP_SUMMARY_DATA_SUCCESS,
  GET_SIP_SUMMARY_DATA_FAILED,
  GET_NFO_SCHEMES,
  GET_NFO_SCHEMES_SUCCESS,
  GET_NFO_SCHEMES_FAILED,
} from "../types";

export const getDashboardData = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Dist_Dashboard",
        params,
        method: "GET",
        types: [
          GET_DASHBOARD_DATA,
          GET_DASHBOARD_DATA_SUCCESS,
          GET_DASHBOARD_DATA_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getTransactionData = (params) => async (dispatch) => {
  try {
    await dispatch({
      [CALL_API]: {
        url: "/Ktrack_Dist_DetailedTransaction",
        params,
        method: "GET",
        types: [
          GET_TRANSACTION_DATA,
          GET_TRANSACTION_DATA_SUCCESS,
          GET_TRANSACTION_DATA_FAILED,
        ],
        showLoader: true,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export const getAumData = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetDistributorAUM",
        params,
        method: "GET",
        types: [GET_AUM_DATA, GET_AUM_DATA_SUCCESS, GET_AUM_DATA_FAILED],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getFrequentMailBackRequest = () => async (dispatch) => {
  try {
    await dispatch({
      [CALL_API]: {
        url: "/ktrack_frequent_mailback_request",
        method: "GET",
        types: [
          GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS,
          GET_FREQUENT_MAIL_BACK_REQUEST,
          GET_FREQUENT_MAIL_BACK_REQUEST_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getDashboardDataAum = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/KtrackDistAumSummary",
        params,
        method: "GET",
        types: [
          GET_DASHBOARD_AUM_DATA,
          GET_DASHBOARD_AUM_DATA_SUCCESS,
          GET_DASHBOARD_AUM_DATA_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getSipSummary = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ktrackGetSipAum",
        params,
        method: "GET",
        types: [
          GET_SIP_SUMMARY_DATA,
          GET_SIP_SUMMARY_DATA_SUCCESS,
          GET_SIP_SUMMARY_DATA_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getNfoSchemes = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetNFOSchemes",
        params,
        method: "GET",
        types: [
          GET_NFO_SCHEMES,
          GET_NFO_SCHEMES_SUCCESS,
          GET_NFO_SCHEMES_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const reinitateTransaction = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_ReinitiateTransaction",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const NfoSchemesSubmission = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SendNFOLink",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
